import { render } from "./ScoreAnalyse.vue?vue&type=template&id=791fd45f&scoped=true&ts=true"
import script from "./ScoreAnalyse.vue?vue&type=script&lang=ts"
export * from "./ScoreAnalyse.vue?vue&type=script&lang=ts"

import "./ScoreAnalyse.vue?vue&type=style&index=0&id=791fd45f&scoped=true&lang=less"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791fd45f"]])

export default __exports__